import { render, staticRenderFns } from "./RegisterPointApply.vue?vue&type=template&id=6cacf374&"
import script from "./RegisterPointApply.vue?vue&type=script&lang=js&"
export * from "./RegisterPointApply.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports